import { lazy } from "react"
import { PermissionProtectedRoute } from "~/router/outlets/PermissionProtectedRoute"
import { OysterRouter } from "~/router/type"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"

const EmploymentComparatorPage = lazy(
  () => import("./pages/EmploymentComparatorPage/EmploymentComparatorPage"),
)

const CompanyResourcesPage = lazy(() => import("./pages/CompanyResourcesPage"))

const CompanyToolkitPage = lazy(() => import("./pages/CompanyToolkitPage"))

const CompanySalaryInsightsResultsPage = lazy(
  () => import("./pages/CompanySalaryInsightsResultsPage"),
)

const CompanySalaryInsightsLandingPage = lazy(
  () => import("./pages/CompanySalaryInsightsLandingPage"),
)

const CompanySalaryInsightsCheckoutPage = lazy(
  () => import("./pages/CompanySalaryInsightsCheckoutPage"),
)

const GlobalSalaryConverterLandingPage = lazy(
  () => import("./pages/GlobalSalaryConverterPage/GlobalSalaryConverterLandingPage"),
)
const GlobalSalaryConverterResultPage = lazy(
  () => import("./pages/GlobalSalaryConverterPage/GlobalSalaryConverterResultPage"),
)

const EmploymentCostComparisonPage = lazy(() => import("~/app/pages/EmploymentCostComparisonPage"))

const WorkforceCompensationReportPage = lazy(
  () => import("./pages/WorkforceCompensationReportPage"),
)

const WorkforceCompensationShellPage = lazy(() => import("./pages/WorkforceCompensationShellPage"))

export const companyOysterIntelligenceRoutes: OysterRouter = {
  "sidebar-shell.custom-layout": [
    {
      path: "workforce-compensation",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <WorkforceCompensationShellPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
  ],
  "fullscreen-shell.center-align.alt-background": [
    {
      path: "workforce-compensation/reports/new",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <WorkforceCompensationReportPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "workforce-compensation/reports/:reportStrongId/edit",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <WorkforceCompensationReportPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
  ],
  DeprecatedLeftSidebar: [
    {
      path: "toolkit",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <PermissionProtectedRoute permissions={["tools_and_resources"]}>
            <CompanyToolkitPage />
          </PermissionProtectedRoute>
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "resources",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <PermissionProtectedRoute permissions={["tools_and_resources"]}>
            <CompanyResourcesPage />
          </PermissionProtectedRoute>
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "salary-insights-tool",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <CompanySalaryInsightsLandingPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "salary-insights-tool/results",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <CompanySalaryInsightsResultsPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "global-salary-converter",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <GlobalSalaryConverterLandingPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "global-salary-converter/results",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <GlobalSalaryConverterResultPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "global-compensation",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <GlobalSalaryConverterLandingPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "employment-comparator",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <EmploymentComparatorPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "employment-cost-comparison",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <EmploymentCostComparisonPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
  ],
  DeprecatedFullScreen: [
    {
      path: "salary-insights-tool/checkout",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <CompanySalaryInsightsCheckoutPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
  ],
}
